import { render, staticRenderFns } from "./detail-group.vue?vue&type=template&id=e551b796&scoped=true"
import script from "./detail-group.vue?vue&type=script&lang=js"
export * from "./detail-group.vue?vue&type=script&lang=js"
import style0 from "./detail-group.vue?vue&type=style&index=0&id=e551b796&prod&lang=less"
import style1 from "./detail-group.vue?vue&type=style&index=1&id=e551b796&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e551b796",
  null
  
)

export default component.exports